import React, { useEffect, useState } from 'react';
import { hasPermission } from '../services/authService';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import './Admin.css';

function IntervalInput({ label, value, onChange, actionButton }) {
  const totalMinutes = parseInt(value, 10) || 0;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return (
      <div className="admin-form-group">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <label className="admin-label" style={{ marginBottom: 0 }}>{label}</label>
          {actionButton}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <div style={{ flex: 1, position: 'relative' }}>
            <input
                type="number"
                min="0"
                className="admin-input"
                style={{ paddingRight: 40 }}
                value={hours}
                onChange={(e) => {
                  const h = parseInt(e.target.value, 10) || 0;
                  onChange(String(h * 60 + minutes));
                }}
            />
            <span style={{ position: 'absolute', right: 12, top: 10, color: '#64748b', fontSize: 13, pointerEvents: 'none' }}>hrs</span>
          </div>
          <div style={{ flex: 1, position: 'relative' }}>
            <input
                type="number"
                min="0"
                max="59"
                className="admin-input"
                style={{ paddingRight: 40 }}
                value={minutes}
                onChange={(e) => {
                  const m = parseInt(e.target.value, 10) || 0;
                  onChange(String(hours * 60 + m));
                }}
            />
            <span style={{ position: 'absolute', right: 12, top: 10, color: '#64748b', fontSize: 13, pointerEvents: 'none' }}>min</span>
          </div>
        </div>
      </div>
  );
}

export default function AdminSettings() {
  const navigate = useNavigate();
  useEffect(() => { if (!hasPermission('admin.settings')) navigate('/login'); }, [navigate]);

  const [settings, setSettings] = useState({
    siteTitle: '',
    siteFavicon: '', // New Favicon setting
    headerTags: '',
    bodyTags: '',
    supportEmail: '',
    exchange_rate_eur: '100', // Default
    exchange_rate_usd: '95',  // Default
    sync_interval_currency: '60',
    sync_interval_globe: '60',
    sync_interval_globe_spec_filters: '60',
    currency_last_sync_at: '',
    globe_last_sync_at: '',
    globe_spec_filters_last_sync_at: '',
    upc_enabled: 'false',
    upc_merchant_id: '',
    upc_terminal_id: '',
    upc_currency: '008',
    upc_gateway_url: '',
    upc_private_key_path: '',
    upc_server_cert_path: '',
    upc_merchant_cert_path: '',
    upc_merchant_name: '',
    upc_language: 'EN',
    upc_order_prefix: '',
    upc_strict_names: false,

    credins_enabled: 'false',
    credins_shopid: '',
    credins_start_key: '',
    credins_api_result_key: '',
    credins_currency: '978',
    credins_gateway_url: '',
    credins_accounting_mode: 'I',
    credins_author_mode: 'I',
    credins_network: '0',
    credins_language: 'AL',
    credins_order_prefix: '',
    payment_server_root: '',

    payment_gateway_mode: 'upc',
    payment_schedule_anchor_date: '2024-01-01',
    payment_schedule_rotation_days: '15',
    payment_schedule_primary: 'upc',

    email_enabled: 'false',
    email_smtp_host: '',
    email_smtp_port: '587',
    email_smtp_user: '',
    email_smtp_pass: '',
    email_smtp_secure: 'false',
    email_from_name: '',
    email_from_email: '',
    email_tpl_processing_subject: '',
    email_tpl_processing_text: '',
    email_tpl_processing_html: '',
    email_tpl_delivered_subject: '',
    email_tpl_delivered_text: '',
    email_tpl_delivered_html: '',
    email_tpl_cancelled_subject: '',
    email_tpl_cancelled_text: '',
    email_tpl_cancelled_html: '',
    email_tpl_returned_subject: '',
    email_tpl_returned_text: '',
    email_tpl_returned_html: '',
    sms_enabled: 'false',
    sms_provider: '',
    sms_api_key: '',
    sms_api_secret: '',
    sms_sender_id: '',
    sms_tpl_processing: '',
    sms_tpl_delivered: '',
    sms_tpl_cancelled: '',
    sms_tpl_returned: '',
    iute_enabled: 'false',
    iute_public_key: '',
    iute_logo: '',
    seoTitle: '',
    seoDescription: '',
    seoImage: '',
    currency_conversion_notice: 'Konvertimi ne EUR/USD eshte vetem informes. Fatura do te leshohet ne Leke',
  });
  const [filterSettings, setFilterSettings] = useState({
    showCategories: true,
    showFocus: true,
    showBrand: true,
    showPrice: true,
    showWarranty: true,
    showRating: true,
    showSpecs: true,
    showStock: true,
    stockStatusLabel: 'Vetëm në stok',
    stockStatusDefault: 'unselected', // 'unselected' | 'selected'
  });
  const [footerSettings, setFooterSettings] = useState({
    columnOrder: ['col1', 'col2', 'col3', 'contact'],
    contactInfo: { title: 'GLOBE', phoneText: '+355 69 40 40 200', phoneHref: 'tel:+355694040200', emailText: 'info@globe.com.al', emailHref: 'mailto:info@globe.com.al', address: 'Autostrada Tiranë - Durrës, Km 4, Tirana, Albania' },
    col1: [
      { id: '1', text: 'Kujdesi per klientin', href: '#', isHeader: true },
      { id: '2', text: 'Rreth Nesh', href: '/rreth-nesh', isHeader: false },
      { id: '3', text: 'Trego Drejtimet', href: '#', isHeader: false },
      { id: '4', text: 'Politikat e rimbursimit', href: '/rimbursimi', isHeader: false },
    ],
    col2: [
      { id: '5', text: 'Afishimi & Fshehtesia', href: '#', isHeader: true },
      { id: '6', text: 'Kushtet e Perdorimit', href: '/kushtet', isHeader: false },
      { id: '7', text: 'Te dhenat e tuaja', href: '#', isHeader: false },
      { id: '8', text: 'Qender ndihme', href: '/ndihme', isHeader: false },
    ],
    col3: [
      { id: '9', text: 'Shërbimet tona', href: '#', isHeader: true },
      { id: '10', text: 'Transporti & Dërgesa', href: '/transporti', isHeader: false },
      { id: '11', text: 'Garancia & Servisi', href: '/garancia', isHeader: false },
      { id: '12', text: 'Dyqanet tona', href: '/locations', isHeader: false },
    ],
    col4: [
      { id: '13', text: 'Informacione', href: '#', isHeader: true },
      { id: '14', text: 'Pyetje të Shpeshta', href: '#', isHeader: false },
      { id: '15', text: 'Katalogu Online', href: '#', isHeader: false },
      { id: '16', text: 'Suport teknik', href: '#', isHeader: false },
    ],
    socialLinks: { facebook: '#fb', instagram: '#ig', whatsapp: '#wa', linkedin: '#li' },
    copyrightText: `© ${new Date().getFullYear()} Globe. All rights reserved.`
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null); // Object { type: 'success' | 'error', text: string }
  const [health, setHealth] = useState({ loading: false, result: null, error: null });
  const [debugLatest, setDebugLatest] = useState({ loading: false, entries: [], error: null });
  const [debugSubmit, setDebugSubmit] = useState({ loading: false, result: null, error: null });
  const [apiPing, setApiPing] = useState({ loading: false, ok: null, status: null, error: null });
  const [currencySync, setCurrencySync] = useState({ loading: false });
  const [activeTab, setActiveTab] = useState('general');
  const [globeImportSync, setGlobeImportSync] = useState({ loading: false });
  const [globeCategorySync, setGlobeCategorySync] = useState({ loading: false });
  const [globeSpecFiltersSync, setGlobeSpecFiltersSync] = useState({ loading: false });

  const formatLastSync = (iso) => {
    if (!iso) return 'Never';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    return d.toLocaleString();
  };

  useEffect(() => {
    // Fetch settings from API
    async function load() {
      try {
        const res = await fetch(`${API_BASE_URL}/settings/all`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (res.ok) {
          const data = await res.json();
          setSettings(prev => ({ ...prev, ...data }));
          if (data && data.filter_settings) {
            try {
              const parsed = typeof data.filter_settings === 'string'
                  ? JSON.parse(data.filter_settings)
                  : data.filter_settings;
              if (parsed && typeof parsed === 'object') {
                setFilterSettings(prev => ({
                  ...prev,
                  ...parsed,
                  stockStatusLabel: (parsed.stockStatusLabel && parsed.stockStatusLabel !== 'Shfaq produktet jashtë stokut')
                    ? parsed.stockStatusLabel
                    : (prev.stockStatusLabel || 'Vetëm në stok'),
                  stockStatusDefault: parsed.stockStatusDefault !== undefined ? parsed.stockStatusDefault : (prev.stockStatusDefault || 'unselected')
                }));
              }
            } catch (e) {
              // ignore invalid JSON
            }
          }
          if (data && data.footer_settings) {
            try {
              const parsed = typeof data.footer_settings === 'string'
                  ? JSON.parse(data.footer_settings)
                  : data.footer_settings;
              if (parsed && typeof parsed === 'object') {
                setFooterSettings(prev => {
                  const merged = { ...prev, ...parsed };
                  merged.col1 = Array.isArray(parsed.col1) && parsed.col1.length > 0 ? parsed.col1 : prev.col1;
                  merged.col2 = Array.isArray(parsed.col2) && parsed.col2.length > 0 ? parsed.col2 : prev.col2;
                  merged.col3 = Array.isArray(parsed.col3) && parsed.col3.length > 0 ? parsed.col3 : prev.col3;
                  merged.col4 = Array.isArray(parsed.col4) && parsed.col4.length > 0 ? parsed.col4 : prev.col4;
                  if (!Array.isArray(parsed.columnOrder) || parsed.columnOrder.length === 0) {
                    merged.columnOrder = ['col1', 'col2', 'col3', 'contact'];
                  } else {
                    merged.columnOrder = [...parsed.columnOrder];
                    if (!merged.columnOrder.includes('col3')) {
                      const cIdx = merged.columnOrder.indexOf('contact');
                      if (cIdx !== -1) {
                        merged.columnOrder.splice(cIdx, 0, 'col3');
                      } else {
                        merged.columnOrder.push('col3');
                      }
                    }
                  }
                  return merged;
                });
              }
            } catch (e) {
              // ignore
            }
          }
        }
      } catch (err) {
        console.error('Failed to load settings', err);
      }
    }
    load();
  }, []);

  const handleChange = (key, val) => {
    setSettings(prev => ({ ...prev, [key]: val }));
  };

  const handleSave = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setSaving(true);
    setMessage(null);
    try {
      const payload = {
        ...settings,
        filter_settings: JSON.stringify(filterSettings || {}),
        footer_settings: JSON.stringify(footerSettings || {}),
      };
      const res = await fetch(`${API_BASE_URL}/settings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        setMessage({ type: 'success', text: 'Settings saved successfully.' });
      } else {
        setMessage({ type: 'error', text: 'Failed to save settings.' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Error saving settings' });
    } finally {
      setSaving(false);
      setTimeout(() => setMessage(null), 4000);
    }
  };

  const handleFooterLinkChange = (colName, index, field, value) => {
    setFooterSettings(prev => {
      const copy = { ...prev };
      if (!copy[colName]) copy[colName] = [];
      const list = [...copy[colName]];
      list[index] = { ...list[index], [field]: value };
      copy[colName] = list;
      return copy;
    });
  };

  const addFooterLink = (colName) => {
    setFooterSettings(prev => {
      const copy = { ...prev };
      if (!copy[colName]) copy[colName] = [];
      copy[colName] = [
        ...copy[colName],
        {
          id: Date.now().toString(),
          text: '',
          href: '',
          isHeader: false
        }
      ];
      return copy;
    });
  };

  const removeFooterLink = (colName, index) => {
    setFooterSettings(prev => {
      const copy = { ...prev };
      if (!copy[colName]) copy[colName] = [];
      copy[colName] = copy[colName].filter((_, i) => i !== index);
      return copy;
    });
  };

  const moveFooterLink = (colName, fromIndex, toIndex) => {
    setFooterSettings(prev => {
      const copy = { ...prev };
      if (!copy[colName]) copy[colName] = [];
      const list = [...copy[colName]];
      if (toIndex < 0 || toIndex >= list.length) return prev;
      const [item] = list.splice(fromIndex, 1);
      list.splice(toIndex, 0, item);
      copy[colName] = list;
      return copy;
    });
  };

  const moveFooterColumn = (fromIndex, toIndex) => {
    setFooterSettings(prev => {
      const order = [...(prev.columnOrder || ['col1', 'col2', 'col3', 'contact'])];
      if (toIndex < 0 || toIndex >= order.length) return prev;
      const [col] = order.splice(fromIndex, 1);
      order.splice(toIndex, 0, col);
      return { ...prev, columnOrder: order };
    });
  };

  const toggleFooterCol4 = () => {
    setFooterSettings(prev => {
      const order = [...(prev.columnOrder || ['col1', 'col2', 'col3', 'contact'])];
      if (order.includes('col4')) {
        return {
          ...prev,
          columnOrder: order.filter(k => k !== 'col4')
        };
      } else {
        return {
          ...prev,
          columnOrder: [...order, 'col4']
        };
      }
    });
  };

  const getFooterColumnName = (colKey) => {
    if (colKey === 'col1') {
      const h = footerSettings.col1?.find(l => l.isHeader);
      return h?.text ? `Kolona 1: ${h.text}` : 'Kolona 1 (Links)';
    }
    if (colKey === 'col2') {
      const h = footerSettings.col2?.find(l => l.isHeader);
      return h?.text ? `Kolona 2: ${h.text}` : 'Kolona 2 (Links)';
    }
    if (colKey === 'col3') {
      const h = footerSettings.col3?.find(l => l.isHeader);
      return h?.text ? `Kolona 3: ${h.text}` : 'Kolona 3 (Links)';
    }
    if (colKey === 'col4') {
      const h = footerSettings.col4?.find(l => l.isHeader);
      return h?.text ? `Kolona 4: ${h.text}` : 'Kolona 4 (Links)';
    }
    if (colKey === 'contact') {
      return `Kontakt & Rrjetet Sociale (${footerSettings.contactInfo?.title || 'GLOBE'})`;
    }
    return colKey;
  };

  const handleFooterContactChange = (field, value) => {
    setFooterSettings(prev => ({
      ...prev,
      contactInfo: { ...prev.contactInfo, [field]: value }
    }));
  };

  const handleFooterSocialChange = (field, value) => {
    setFooterSettings(prev => ({
      ...prev,
      socialLinks: { ...prev.socialLinks, [field]: value }
    }));
  };

  const uploadSettingImage = async (file, key) => {
    setMessage(null);
    try {
      const fd = new FormData();
      fd.append('image', file);
      const res = await fetch(`${API_BASE_URL}/settings/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: fd
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || 'Failed to upload image');
      }
      setSettings(prev => ({ ...prev, [key]: data.url }));
      setMessage({ type: 'success', text: 'Image uploaded successfully. Remember to save changes.' });
    } catch (e) {
      setMessage({ type: 'error', text: e.message });
    } finally {
      setTimeout(() => setMessage(null), 4000);
    }
  };



  const handleSyncCurrency = async () => {
    if (currencySync.loading) return;
    setCurrencySync({ loading: true });
    setMessage(null);
    try {
      const res = await fetch(`${API_BASE_URL}/settings/sync-currency`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const ct = res.headers.get('content-type') || '';
      let data = null;
      let nonJsonText = null;
      if (ct.includes('application/json')) {
        data = await res.json().catch(() => null);
      } else {
        nonJsonText = await res.text().catch(() => null);
      }

      if (!res.ok) {
        const errMsg = data?.error || data?.message || (nonJsonText
            ? `Non-JSON response (${res.status}): ${String(nonJsonText).slice(0, 160)}`
            : `Failed to sync currency (${res.status}).`);
        setMessage({ type: 'error', text: errMsg });
        return;
      }

      const syncedAt = data?.result?.syncedAt;
      const rates = data?.result?.rates;
      if (syncedAt) {
        setSettings(prev => ({
          ...prev,
          currency_last_sync_at: syncedAt,
          ...(rates?.EUR ? { exchange_rate_eur: String(rates.EUR) } : null),
          ...(rates?.USD ? { exchange_rate_usd: String(rates.USD) } : null),
        }));
      }
      const summary = (rates && (rates.EUR || rates.USD))
          ? `Currency sync completed. EUR: ${rates.EUR ?? '-'} ALL, USD: ${rates.USD ?? '-'} ALL.`
          : 'Currency sync completed.';
      setMessage({ type: 'success', text: summary });
    } catch (e) {
      setMessage({ type: 'error', text: e.message || 'Error syncing currency.' });
    } finally {
      setCurrencySync({ loading: false });
      setTimeout(() => setMessage(null), 5000);
    }
  };

  const handleImportGlobeProducts = async () => {
    if (globeImportSync.loading) return;
    setGlobeImportSync({ loading: true });
    setMessage(null);
    try {
      const res = await fetch(`${API_BASE_URL}/settings/import-globe-products`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) {
        const errMsg = data?.error || data?.message || 'Failed to import Globe products.';
        setMessage({ type: 'error', text: errMsg });
        return;
      }
      const syncedAt = data?.result?.syncedAt;
      if (syncedAt) {
        setSettings(prev => ({ ...prev, globe_last_sync_at: syncedAt }));
      }
      const r = data?.result;
      const summary = r
          ? `Globe refresh/import completed. Processed ${r.processedCount ?? r.totalFetchedCount ?? 0} items (created ${r.created ?? 0}, updated ${r.updated ?? 0}, skipped ${r.skipped ?? 0}, disabled ${r.disabled ?? 0}).`
          : 'Globe refresh/import completed.';
      setMessage({ type: 'success', text: summary });
    } catch (e) {
      setMessage({ type: 'error', text: e.message || 'Error importing Globe products.' });
    } finally {
      setGlobeImportSync({ loading: false });
      setTimeout(() => setMessage(null), 5000);
    }
  };

  const handleSyncGlobeCategories = async () => {
    if (globeCategorySync.loading) return;
    setGlobeCategorySync({ loading: true });
    setMessage(null);
    try {
      const res = await fetch(`${API_BASE_URL}/settings/sync-globe-categories`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) {
        setMessage({ type: 'error', text: data?.error || 'Failed to sync categories.' });
        return;
      }
      const r = data?.result;
      if (r?.syncedAt) setSettings(prev => ({ ...prev, globe_category_last_sync_at: r.syncedAt }));
      const summary = r
          ? `Category sync completed. Created ${r.created ?? 0}, updated ${r.updated ?? 0}, deleted ${r.deleted ?? 0} (total ${r.total ?? 0}).`
          : 'Category sync completed.';
      setMessage({ type: 'success', text: summary });
    } catch (e) {
      setMessage({ type: 'error', text: e.message || 'Error syncing categories.' });
    } finally {
      setGlobeCategorySync({ loading: false });
      setTimeout(() => setMessage(null), 5000);
    }
  };

  const handleSyncGlobeSpecFilters = async () => {
    if (globeSpecFiltersSync.loading) return;
    setGlobeSpecFiltersSync({ loading: true });
    setMessage(null);
    try {
      const res = await fetch(`${API_BASE_URL}/settings/sync-globe-spec-filters`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) {
        setMessage({ type: 'error', text: data?.error || 'Failed to sync spec filters.' });
        return;
      }
      const r = data?.result;
      if (r?.syncedAt) setSettings(prev => ({ ...prev, globe_spec_filters_last_sync_at: r.syncedAt }));
      const summary = r
          ? `Spec filters sync completed. Updated specifications for ${r.updated ?? 0} categories.`
          : 'Spec filters sync completed.';
      setMessage({ type: 'success', text: summary });
    } catch (e) {
      setMessage({ type: 'error', text: e.message || 'Error syncing spec filters.' });
    } finally {
      setGlobeSpecFiltersSync({ loading: false });
      setTimeout(() => setMessage(null), 5000);
    }
  };


  const runHealthCheck = async () => {
    setHealth({ loading: true, result: null, error: null });
    try {
      const res = await fetch(`${API_BASE_URL}/payment/health`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || 'Health check failed');
      setHealth({ loading: false, result: data, error: null });
    } catch (e) {
      setHealth({ loading: false, result: null, error: e.message });
    }
  };

  const loadDebugLatest = async () => {
    setDebugLatest({ loading: true, entries: [], error: null });
    try {
      const res = await fetch(`${API_BASE_URL}/payment/debug-latest`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const ct = res.headers.get('content-type') || '';
      if (!ct.includes('application/json')) {
        const txt = await res.text();
        throw new Error(`Non-JSON response (${res.status}): ${txt.slice(0, 160)}`);
      }
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || 'Failed to load latest payloads');
      const entries = Array.isArray(data.entries) ? data.entries : [];
      setDebugLatest({ loading: false, entries, error: null });
      return entries;
    } catch (e) {
      setDebugLatest({ loading: false, entries: [], error: e.message });
      return [];
    }
  };

  const replayLatest = async () => {
    try {
      setDebugSubmit({ loading: true, result: null, error: null });
      // Ensure we have at least one entry
      let entries = debugLatest.entries;
      if (!entries || !entries.length) {
        entries = await loadDebugLatest();
      }
      const last = (entries && entries.length) ? entries[entries.length - 1] : null;
      if (!last || !last.fields) throw new Error('No latest payload available');
      const res = await fetch(`${API_BASE_URL}/payment/debug-submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ fields: last.fields })
      });
      const ct = res.headers.get('content-type') || '';
      if (!ct.includes('application/json')) {
        const txt = await res.text();
        throw new Error(`Non-JSON response (${res.status}): ${txt.slice(0, 160)}`);
      }
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || 'Debug submit failed');
      setDebugSubmit({ loading: false, result: data, error: null });
    } catch (e) {
      setDebugSubmit({ loading: false, result: null, error: e.message });
    }
  };

  const replayLatestGoPay = async () => {
    try {
      setDebugSubmit({ loading: true, result: null, error: null });

      let entries = debugLatest.entries;
      if (!entries || !entries.length) {
        entries = await loadDebugLatest();
      }

      const lastGoPay = (entries || []).slice().reverse().find(e => {
        if (!e || typeof e !== 'object') return false;
        if (e.kind === 'sign-js') return true;
        const url = String(e.actionUrl || '');
        return /\/go\/pay\b/i.test(url);
      });

      if (!lastGoPay) throw new Error('No go/pay payload found in latest entries');

      const orderIdRaw = (lastGoPay.orderId || lastGoPay.fields?.OrderID || '').toString();
      const orderId = Number.parseInt(orderIdRaw, 10);
      if (!Number.isFinite(orderId) || orderId <= 0) {
        throw new Error(`Cannot derive numeric orderId from "${orderIdRaw}"`);
      }

      const res = await fetch(`${API_BASE_URL}/payment/debug-submit-js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ orderId })
      });

      const ct = res.headers.get('content-type') || '';
      if (!ct.includes('application/json')) {
        const txt = await res.text();
        throw new Error(`Non-JSON response (${res.status}): ${txt.slice(0, 160)}`);
      }
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || 'Debug submit (go/pay) failed');
      setDebugSubmit({ loading: false, result: data, error: null });
    } catch (e) {
      setDebugSubmit({ loading: false, result: null, error: e.message });
    }
  };

  const pingApi = async () => {
    setApiPing({ loading: true, ok: null, status: null, error: null });
    try {
      const root = API_BASE_URL.replace(/\/api$/, '');
      const res = await fetch(`${root}/test`);
      setApiPing({ loading: false, ok: res.ok, status: res.status, error: null });
    } catch (e) {
      setApiPing({ loading: false, ok: null, status: null, error: e.message });
    }
  };

  return (
      <div>




        <div style={{ padding: '0 20px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, paddingBottom: 16, borderBottom: '1px solid #e2e8f0' }}>
            <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', WebkitOverflowScrolling: 'touch', flex: 1 }}>
              {[
                { id: 'general', label: 'General Info', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg> },
                { id: 'display', label: 'Store Display', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" /></svg> },
                { id: 'regional', label: 'Regional', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> },
                { id: 'payments', label: 'Payments', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg> },
                { id: 'sync', label: 'Background Sync', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg> },
                { id: 'email', label: 'Email', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg> },
                { id: 'sms', label: 'SMS', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg> },
              ].map(tab => (
                  <button
                      key={tab.id}
                      type="button"
                      onClick={() => setActiveTab(tab.id)}
                      style={{
                        display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', borderRadius: '8px',
                        background: activeTab === tab.id ? '#f1f5f9' : 'transparent',
                        color: activeTab === tab.id ? '#0f172a' : '#64748b',
                        fontWeight: activeTab === tab.id ? '600' : '500',
                        border: 'none', cursor: 'pointer', whiteSpace: 'nowrap', fontSize: '14px', transition: 'all 0.2s', flexShrink: 0
                      }}
                      onMouseEnter={(e) => { if (activeTab !== tab.id) { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.color = '#334155'; } }}
                      onMouseLeave={(e) => { if (activeTab !== tab.id) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#64748b'; } }}
                  >
                    <div style={{ color: activeTab === tab.id ? '#0b74de' : '#94a3b8' }}>{tab.icon}</div>
                    {tab.label}
                  </button>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginLeft: 16 }}>
              <button type="button" onClick={handleSave} className="admin-btn admin-btn-primary" disabled={saving} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                {saving ? 'Saving...' : 'Save Settings'}
              </button>
            </div>
          </div>

          <form onSubmit={handleSave} style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 24, paddingBottom: 60, minWidth: 0, width: '100%' }}>

            {activeTab === 'general' && (
                <>

                  <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 -8px', paddingBottom: 8 }}>General Info</h2>
                  <div className="admin-card">
                    <h3 className="admin-subtitle">General Information</h3>
                    <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Store Name</label>
                        <input
                            className="admin-input"
                            value={settings.siteTitle}
                            onChange={(e) => handleChange('siteTitle', e.target.value)}
                            placeholder="e.g. My Awesome Store"
                        />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Support Email</label>
                        <input
                            className="admin-input"
                            value={settings.supportEmail}
                            onChange={(e) => handleChange('supportEmail', e.target.value)}
                            placeholder="support@example.com"
                        />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Favicon URL</label>
                        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                          <input
                              className="admin-input"
                              style={{ flex: 1, marginBottom: 0 }}
                              value={settings.siteFavicon || ''}
                              onChange={(e) => handleChange('siteFavicon', e.target.value)}
                              placeholder="/uploads/favicon.png"
                          />
                          <label className="admin-btn admin-btn-secondary admin-btn-sm" style={{ flexShrink: 0, margin: 0 }}>
                            Upload Favicon
                            <input type="file" hidden accept="image/*,.ico" onChange={(e) => { if (e.target.files && e.target.files[0]) uploadSettingImage(e.target.files[0], 'siteFavicon'); }} />
                          </label>
                          {settings.siteFavicon && (
                              <div style={{ width: 32, height: 32, flexShrink: 0, borderRadius: 4, overflow: 'hidden', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img src={settings.siteFavicon.startsWith('http') ? settings.siteFavicon : `${API_BASE_URL.replace('/api', '')}${settings.siteFavicon}`} alt="favicon" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                              </div>
                          )}
                        </div>
                      </div>
                      <div className="admin-form-group" style={{ gridColumn: '1 / -1' }}>
                        <label className="admin-label">Global Header Tags (e.g. Google Analytics)</label>
                        <p className="admin-text" style={{ marginTop: -4, marginBottom: 8 }}>These tags will be injected into the &lt;head&gt; of every page. Use for tracking scripts, meta tags, etc.</p>
                        <textarea
                            className="admin-input"
                            style={{ minHeight: 120, fontFamily: 'monospace', fontSize: 13, resize: 'vertical' }}
                            value={settings.headerTags || ''}
                            onChange={(e) => handleChange('headerTags', e.target.value)}
                            placeholder="<script async src='https://www.googletagmanager.com/gtag/js?id=G-XXXXX'></script>&#10;<script>&#10;  window.dataLayer = window.dataLayer || [];&#10;  function gtag(){dataLayer.push(arguments);}&#10;  gtag('js', new Date());&#10;  gtag('config', 'G-XXXXX');&#10;</script>"
                        />
                      </div>
                      <div className="admin-form-group" style={{ gridColumn: '1 / -1' }}>
                        <label className="admin-label">Global Body Tags (e.g. Google Tag Manager Noscript)</label>
                        <p className="admin-text" style={{ marginTop: -4, marginBottom: 8 }}>These tags will be injected into the &lt;body&gt; of every page. Use for noscript fallbacks, tracking pixels, or body scripts.</p>
                        <textarea
                            className="admin-input"
                            style={{ minHeight: 120, fontFamily: 'monospace', fontSize: 13, resize: 'vertical' }}
                            value={settings.bodyTags || ''}
                            onChange={(e) => handleChange('bodyTags', e.target.value)}
                            placeholder="<!-- Google Tag Manager (noscript) -->&#10;<noscript><iframe src='https://www.googletagmanager.com/ns.html?id=GTM-XXXXX' height='0' width='0' style='display:none;visibility:hidden'></iframe></noscript>&#10;<!-- End Google Tag Manager (noscript) -->"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="admin-card" style={{ marginTop: 24 }}>
                    <h3 className="admin-subtitle">SEO & Social Sharing</h3>
                    <p className="admin-text" style={{ marginBottom: 16 }}>
                      Customize how your website appears on Google Search and when shared on social media (WhatsApp, Facebook, etc.).
                    </p>
                    <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">SEO Title</label>
                        <input
                            className="admin-input"
                            value={settings.seoTitle || ''}
                            onChange={(e) => handleChange('seoTitle', e.target.value)}
                            placeholder="e.g. My Website - Buy Electronics Online"
                        />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">SEO Description</label>
                        <textarea
                            className="admin-input"
                            style={{ minHeight: 80, resize: 'vertical' }}
                            value={settings.seoDescription || ''}
                            onChange={(e) => handleChange('seoDescription', e.target.value)}
                            placeholder="A short description of your website for search engines."
                        />
                      </div>
                      <div className="admin-form-group" style={{ gridColumn: '1 / -1' }}>
                        <label className="admin-label">Shared Link Image (OpenGraph)</label>
                        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                          <input
                              className="admin-input"
                              style={{ flex: 1, marginBottom: 0 }}
                              value={settings.seoImage || ''}
                              onChange={(e) => handleChange('seoImage', e.target.value)}
                              placeholder="/uploads/seo-image.png"
                          />
                          <label className="admin-btn admin-btn-secondary admin-btn-sm" style={{ flexShrink: 0, margin: 0 }}>
                            Upload Image
                            <input type="file" hidden accept="image/*" onChange={(e) => { if (e.target.files && e.target.files[0]) uploadSettingImage(e.target.files[0], 'seoImage'); }} />
                          </label>
                          {settings.seoImage && (
                              <div style={{ width: 64, height: 64, flexShrink: 0, borderRadius: 4, overflow: 'hidden', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img src={settings.seoImage.startsWith('http') ? settings.seoImage : `${API_BASE_URL.replace('/api', '')}${settings.seoImage}`} alt="seo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'cover' }} />
                              </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                </>
            )}

            {activeTab === 'display' && (
                <>
                  <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 -8px', paddingBottom: 8 }}>Store Display</h2>
                  <div className="admin-card">
                    <h3 className="admin-subtitle">Product Filters</h3>
                    <div className="admin-text" style={{ marginBottom: 12 }}>
                      Enable or disable filter sections on the public products page.
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
                      {[
                        { id: 'showCategories', label: 'Categories', desc: 'Allow browsing by hierarchy', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" /></svg> },
                        { id: 'showFocus', label: 'Offer Focus', desc: 'New, Offer, and Special badges', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" /></svg> },
                        { id: 'showBrand', label: 'Brands', desc: 'Filter by manufacturer', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg> },
                        { id: 'showPrice', label: 'Price Range', desc: 'Dynamic price slider', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zM17 13v-3a5 5 0 00-10 0v3a5 5 0 0010 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18V6" /></svg> },
                        { id: 'showWarranty', label: 'Warranty', desc: 'Filter by duration', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg> },
                        { id: 'showRating', label: 'Ratings', desc: 'Star ratings and reviews', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg> },
                        { id: 'showSpecs', label: 'Specifications', desc: 'Tech specs (RAM, Storage)', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" /></svg> },
                        {
                          id: 'showStock',
                          label: 'Stock Status',
                          desc: filterSettings.showStock
                            ? `Aktiv • "${filterSettings.stockStatusLabel || 'Vetëm në stok'}" (${filterSettings.stockStatusDefault === 'selected' ? 'Përzgjedhur' : 'Papërzgjedhur'})`
                            : 'Filtruesi i gjendjes së stokut',
                          icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>
                        },
                      ].map((filter) => (
                          <div
                              key={filter.id}
                              onClick={() => setFilterSettings(prev => ({ ...prev, [filter.id]: !prev[filter.id] }))}
                              style={{
                                padding: '12px',
                                background: filterSettings[filter.id] ? '#f1f5f9' : '#ffffff',
                                borderRadius: '10px',
                                border: '1px solid',
                                borderColor: filterSettings[filter.id] ? '#cbd5e1' : '#e2e8f0',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: filterSettings[filter.id] ? 'inset 0 1px 2px 0 rgba(0, 0, 0, 0.05)' : 'none'
                              }}
                              onMouseEnter={(e) => {
                                if (!filterSettings[filter.id]) {
                                  e.currentTarget.style.borderColor = '#cbd5e1';
                                  e.currentTarget.style.background = '#f8fafc';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!filterSettings[filter.id]) {
                                  e.currentTarget.style.borderColor = '#e2e8f0';
                                  e.currentTarget.style.background = '#ffffff';
                                }
                              }}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <div style={{
                                width: '32px', height: '32px', borderRadius: '8px', background: filterSettings[filter.id] ? '#ffffff' : '#f8fafc',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', color: filterSettings[filter.id] ? '#0b74de' : '#64748b',
                                border: '1px solid #e2e8f0'
                              }}>
                                {filter.icon}
                              </div>
                              <div style={{
                                width: '32px', height: '18px', background: filterSettings[filter.id] ? '#0b74de' : '#cbd5e1',
                                borderRadius: '9px', position: 'relative', transition: '0.2s'
                              }}>
                                <div style={{
                                  width: '12px', height: '12px', background: '#fff', borderRadius: '50%',
                                  position: 'absolute', top: '3px', left: filterSettings[filter.id] ? '17px' : '3px',
                                  transition: '0.2s'
                                }} />
                              </div>
                            </div>
                            <div>
                              <div style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a' }}>{filter.label}</div>
                              <div style={{ fontSize: '11px', color: '#64748b', marginTop: '1px', lineHeight: '1.3' }}>{filter.desc}</div>
                            </div>
                          </div>
                      ))}
                    </div>

                    {/* Stock Status Configuration Box */}
                    {filterSettings.showStock && (
                      <div style={{
                        marginTop: 20,
                        padding: '18px 20px',
                        background: '#f8fafc',
                        border: '1.5px solid #cbd5e1',
                        borderRadius: '12px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.02)'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
                          <span style={{ fontSize: 20 }}>📦</span>
                          <div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>
                              Konfigurimi i Filtruesit "Stock Status"
                            </div>
                            <div style={{ fontSize: 12, color: '#64748b' }}>
                              Personalizoni tekstin e butonit/checkbox-it dhe përcaktoni gjendjen fillestare kur vizitori hap listën e produkteve.
                            </div>
                          </div>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 18 }}>
                          {/* Label input */}
                          <div>
                            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#334155', marginBottom: 6 }}>
                              Teksti i Butonit / Checkbox-it (Button Text):
                            </label>
                            <input
                              type="text"
                              className="admin-input"
                              value={filterSettings.stockStatusLabel !== undefined ? filterSettings.stockStatusLabel : 'Vetëm në stok'}
                              onChange={(e) => setFilterSettings(prev => ({ ...prev, stockStatusLabel: e.target.value }))}
                              placeholder="Vetëm në stok"
                              style={{ background: '#fff', fontWeight: 600 }}
                            />
                            <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>
                              Ky tekst do të shfaqet në shiritin e filtrave mbi produktet në dyqan (p.sh. &quot;Vetëm në stok&quot;).
                            </div>
                          </div>

                          {/* Default state selector */}
                          <div>
                            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#334155', marginBottom: 6 }}>
                              Gjendja Fillestare (Default State):
                            </label>
                            <div style={{ display: 'flex', gap: 10 }}>
                              <button
                                type="button"
                                onClick={() => setFilterSettings(prev => ({ ...prev, stockStatusDefault: 'unselected' }))}
                                style={{
                                  flex: 1,
                                  padding: '9px 12px',
                                  borderRadius: 8,
                                  border: (filterSettings.stockStatusDefault === 'unselected' || !filterSettings.stockStatusDefault)
                                    ? '2px solid #007da5'
                                    : '1px solid #cbd5e1',
                                  background: (filterSettings.stockStatusDefault === 'unselected' || !filterSettings.stockStatusDefault)
                                    ? '#e0f2fe'
                                    : '#fff',
                                  color: (filterSettings.stockStatusDefault === 'unselected' || !filterSettings.stockStatusDefault)
                                    ? '#0369a1'
                                    : '#475569',
                                  fontWeight: 700,
                                  fontSize: 12.5,
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: 6,
                                  transition: 'all 0.15s ease'
                                }}
                              >
                                <span>◻️</span>
                                <span>E Papërzgjedhur (Unselected)</span>
                              </button>

                              <button
                                type="button"
                                onClick={() => setFilterSettings(prev => ({ ...prev, stockStatusDefault: 'selected' }))}
                                style={{
                                  flex: 1,
                                  padding: '9px 12px',
                                  borderRadius: 8,
                                  border: filterSettings.stockStatusDefault === 'selected'
                                    ? '2px solid #007da5'
                                    : '1px solid #cbd5e1',
                                  background: filterSettings.stockStatusDefault === 'selected'
                                    ? '#e0f2fe'
                                    : '#fff',
                                  color: filterSettings.stockStatusDefault === 'selected'
                                    ? '#0369a1'
                                    : '#475569',
                                  fontWeight: 700,
                                  fontSize: 12.5,
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: 6,
                                  transition: 'all 0.15s ease'
                                }}
                              >
                                <span>☑️</span>
                                <span>E Përzgjedhur (Selected)</span>
                              </button>
                            </div>
                            <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>
                              {filterSettings.stockStatusDefault === 'selected'
                                ? 'Kur hapet dyqani, filtruesi është i përzgjedhur (Checked) dhe shfaqen menjëherë vetëm produktet në stok.'
                                : 'Kur hapet dyqani, filtruesi është i papërzgjedhur (Unchecked) dhe shfaqen të gjitha produktet. Kur vizitori e përzgjedh, shfaqen vetëm produktet që janë në stok.'}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Checkout / Shporta — Njoftimi i Monedhës</h3>
                    <div className="admin-text" style={{ marginBottom: 12 }}>
                      Ky tekst shfaqet në kartën e shportës kur përdoruesi zgjedh monedhën EUR ose USD.
                    </div>
                    <div className="admin-form-group">
                      <label className="admin-label">Teksti Informues (EUR / USD)</label>
                      <textarea
                        className="admin-input"
                        rows={3}
                        value={settings.currency_conversion_notice !== undefined ? settings.currency_conversion_notice : 'Konvertimi ne EUR/USD eshte vetem informes. Fatura do te leshohet ne Leke'}
                        onChange={(e) => handleChange('currency_conversion_notice', e.target.value)}
                        placeholder="Konvertimi ne EUR/USD eshte vetem informes. Fatura do te leshohet ne Leke"
                      />
                      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
                        Shfaqet automatikisht në shportë vetëm kur monedha aktive është Euro (EUR) ose Dollar (USD).
                      </div>
                    </div>
                  </div>

                  <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '32px 0 16px', borderBottom: '2px solid #e2e8f0', paddingBottom: 8 }}>Footer Settings</h2>
                  <div className="admin-card">
                    <h3 className="admin-subtitle">Contact Information</h3>
                    <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Title</label>
                        <input className="admin-input" value={footerSettings.contactInfo.title} onChange={(e) => handleFooterContactChange('title', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Phone Label</label>
                        <input className="admin-input" value={footerSettings.contactInfo.phoneText} onChange={(e) => handleFooterContactChange('phoneText', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Phone Href (e.g. tel:...)</label>
                        <input className="admin-input" value={footerSettings.contactInfo.phoneHref} onChange={(e) => handleFooterContactChange('phoneHref', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Email Label</label>
                        <input className="admin-input" value={footerSettings.contactInfo.emailText} onChange={(e) => handleFooterContactChange('emailText', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Email Href (e.g. mailto:...)</label>
                        <input className="admin-input" value={footerSettings.contactInfo.emailHref} onChange={(e) => handleFooterContactChange('emailHref', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Address</label>
                        <input className="admin-input" value={footerSettings.contactInfo.address} onChange={(e) => handleFooterContactChange('address', e.target.value)} />
                      </div>
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Social Links</h3>
                    <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Facebook URL</label>
                        <input className="admin-input" value={footerSettings.socialLinks.facebook} onChange={(e) => handleFooterSocialChange('facebook', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Instagram URL</label>
                        <input className="admin-input" value={footerSettings.socialLinks.instagram} onChange={(e) => handleFooterSocialChange('instagram', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">WhatsApp URL</label>
                        <input className="admin-input" value={footerSettings.socialLinks.whatsapp} onChange={(e) => handleFooterSocialChange('whatsapp', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">LinkedIn URL</label>
                        <input className="admin-input" value={footerSettings.socialLinks.linkedin} onChange={(e) => handleFooterSocialChange('linkedin', e.target.value)} />
                      </div>
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Footer Copyright</h3>
                    <div className="admin-form-group" style={{ marginBottom: 0 }}>
                      <input
                          className="admin-input"
                          value={footerSettings.copyrightText || ''}
                          onChange={(e) => setFooterSettings(prev => ({ ...prev, copyrightText: e.target.value }))}
                          placeholder={`© ${new Date().getFullYear()} Globe. All rights reserved.`}
                      />
                    </div>
                  </div>

                  {/* Reordering Ribbon */}
                  <div className="admin-card" style={{ background: '#f8fafc', border: '1.5px solid #e2e8f0', borderRadius: 12, padding: '20px', marginBottom: 24 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
                      <div>
                        <h3 className="admin-subtitle" style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span>Renditja e Kolonave të Footer-it</span>
                          <span style={{ fontSize: 12, background: '#e0f2fe', color: '#007da5', padding: '2px 8px', borderRadius: 12, fontWeight: 700 }}>
                            {(footerSettings.columnOrder || []).length} Kolona Aktive
                          </span>
                        </h3>
                        <p className="admin-text" style={{ margin: '4px 0 0 0', fontSize: 13, color: '#64748b' }}>
                          Përdorni butonat ◀ dhe ▶ për të ndryshuar radhën e kolonave. Renditja ruhet dhe aplikohet drejtpërdrejt në faqen kryesore.
                        </p>
                      </div>
                      <button
                        type="button"
                        onClick={toggleFooterCol4}
                        className="admin-btn admin-btn-sm admin-btn-secondary"
                        style={{ display: 'flex', alignItems: 'center', gap: 6 }}
                      >
                        {footerSettings.columnOrder?.includes('col4') ? '− Hiq Kolonën 4' : '+ Shto Kolonën 4 (Links)'}
                      </button>
                    </div>

                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'stretch' }}>
                      {(footerSettings.columnOrder || ['col1', 'col2', 'col3', 'contact']).map((colKey, idx, arr) => (
                        <div
                          key={colKey}
                          style={{
                            flex: '1 1 200px',
                            minWidth: 190,
                            background: '#fff',
                            border: '1.5px solid #cbd5e1',
                            borderRadius: 10,
                            padding: '12px 14px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                            <span style={{
                              fontSize: 11,
                              fontWeight: 800,
                              background: '#007da5',
                              color: '#fff',
                              padding: '2px 8px',
                              borderRadius: 6,
                              letterSpacing: '0.5px'
                            }}>
                              KOLONA #{idx + 1}
                            </span>
                            <div style={{ display: 'flex', gap: 4 }}>
                              <button
                                type="button"
                                disabled={idx === 0}
                                onClick={() => moveFooterColumn(idx, idx - 1)}
                                className="admin-btn admin-btn-sm admin-btn-secondary"
                                style={{ padding: '3px 8px', opacity: idx === 0 ? 0.4 : 1, cursor: idx === 0 ? 'default' : 'pointer' }}
                                title="Lëviz majtas"
                              >
                                ◀
                              </button>
                              <button
                                type="button"
                                disabled={idx === arr.length - 1}
                                onClick={() => moveFooterColumn(idx, idx + 1)}
                                className="admin-btn admin-btn-sm admin-btn-secondary"
                                style={{ padding: '3px 8px', opacity: idx === arr.length - 1 ? 0.4 : 1, cursor: idx === arr.length - 1 ? 'default' : 'pointer' }}
                                title="Lëviz djathtas"
                              >
                                ▶
                              </button>
                            </div>
                          </div>
                          <div style={{ fontWeight: 600, fontSize: 13.5, color: '#1e293b' }}>
                            {getFooterColumnName(colKey)}
                          </div>
                          <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>
                            {colKey === 'contact' ? 'Kontakt & Rrjetet Sociale' : `${(footerSettings[colKey] || []).length} link-e`}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))', gap: 24 }}>
                    {(footerSettings.columnOrder || ['col1', 'col2', 'col3', 'contact']).map((colKey, colIdx, arr) => {
                      if (colKey === 'contact') {
                        return (
                          <div key="contact" className="admin-card" style={{ marginBottom: 0, background: '#fcfdfe', border: '1.5px solid #dbeafe' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <h3 className="admin-subtitle" style={{ margin: 0 }}>Kolona: Kontakt & Social</h3>
                                <span style={{ fontSize: 11, background: '#007da5', color: '#fff', padding: '2px 8px', borderRadius: 6, fontWeight: 700 }}>
                                  #{colIdx + 1}
                                </span>
                              </div>
                              <div style={{ display: 'flex', gap: 4 }}>
                                <button
                                  type="button"
                                  disabled={colIdx === 0}
                                  onClick={() => moveFooterColumn(colIdx, colIdx - 1)}
                                  className="admin-btn admin-btn-sm admin-btn-secondary"
                                  style={{ padding: '4px 8px', opacity: colIdx === 0 ? 0.4 : 1 }}
                                  title="Lëviz kolonën majtas"
                                >
                                  ◀
                                </button>
                                <button
                                  type="button"
                                  disabled={colIdx === arr.length - 1}
                                  onClick={() => moveFooterColumn(colIdx, colIdx + 1)}
                                  className="admin-btn admin-btn-sm admin-btn-secondary"
                                  style={{ padding: '4px 8px', opacity: colIdx === arr.length - 1 ? 0.4 : 1 }}
                                  title="Lëviz kolonën djathtas"
                                >
                                  ▶
                                </button>
                              </div>
                            </div>
                            <div style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, background: '#fff', padding: 14, borderRadius: 8, border: '1px solid #e2e8f0' }}>
                              <p style={{ margin: '0 0 8px 0', fontWeight: 600, color: '#0f172a' }}>
                                Informacioni i shfaqur në këtë kolonë:
                              </p>
                              <div><strong>Titulli:</strong> {footerSettings.contactInfo?.title || 'GLOBE'}</div>
                              <div><strong>Telefon:</strong> {footerSettings.contactInfo?.phoneText || '-'}</div>
                              <div><strong>Email:</strong> {footerSettings.contactInfo?.emailText || '-'}</div>
                              <div><strong>Adresë:</strong> {footerSettings.contactInfo?.address || '-'}</div>
                              <div style={{ marginTop: 8, fontSize: 12, color: '#64748b' }}>
                                Mund të modifikoni këto fusha në seksionet <em>Contact Information</em> dhe <em>Social Links</em> më lart.
                              </div>
                            </div>
                          </div>
                        );
                      }

                      const colTitleMap = {
                        col1: 'Kolona 1 Links',
                        col2: 'Kolona 2 Links',
                        col3: 'Kolona 3 Links',
                        col4: 'Kolona 4 Links'
                      };
                      const colTitle = colTitleMap[colKey] || `${colKey.toUpperCase()} Links`;
                      const links = footerSettings[colKey] || [];

                      return (
                        <div key={colKey} className="admin-card" style={{ marginBottom: 0 }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <h3 className="admin-subtitle" style={{ margin: 0 }}>{colTitle}</h3>
                              <span style={{ fontSize: 11, background: '#007da5', color: '#fff', padding: '2px 8px', borderRadius: 6, fontWeight: 700 }}>
                                #{colIdx + 1}
                              </span>
                            </div>
                            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                              <button
                                type="button"
                                disabled={colIdx === 0}
                                onClick={() => moveFooterColumn(colIdx, colIdx - 1)}
                                className="admin-btn admin-btn-sm admin-btn-secondary"
                                style={{ padding: '4px 8px', opacity: colIdx === 0 ? 0.4 : 1 }}
                                title="Lëviz kolonën majtas"
                              >
                                ◀
                              </button>
                              <button
                                type="button"
                                disabled={colIdx === arr.length - 1}
                                onClick={() => moveFooterColumn(colIdx, colIdx + 1)}
                                className="admin-btn admin-btn-sm admin-btn-secondary"
                                style={{ padding: '4px 8px', opacity: colIdx === arr.length - 1 ? 0.4 : 1 }}
                                title="Lëviz kolonën djathtas"
                              >
                                ▶
                              </button>
                              <button
                                type="button"
                                onClick={() => addFooterLink(colKey)}
                                className="admin-btn admin-btn-sm"
                                style={{ marginLeft: 4 }}
                              >
                                + Add
                              </button>
                            </div>
                          </div>

                          {links.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '24px 12px', color: '#94a3b8', fontSize: 13, border: '1.5px dashed #e2e8f0', borderRadius: 8 }}>
                              Nuk ka asnjë link në këtë kolonë. Klikoni <strong>+ Add</strong> për të shtuar.
                            </div>
                          ) : (
                            links.map((link, idx) => (
                              <div key={link.id || idx} style={{ display: 'flex', gap: 6, marginBottom: 10, alignItems: 'center' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                  <button
                                    type="button"
                                    disabled={idx === 0}
                                    onClick={() => moveFooterLink(colKey, idx, idx - 1)}
                                    className="admin-btn admin-btn-sm admin-btn-secondary"
                                    style={{ padding: '2px 5px', fontSize: 9, lineHeight: 1, minHeight: 'auto', opacity: idx === 0 ? 0.3 : 1 }}
                                    title="Lëviz lart"
                                  >
                                    ▲
                                  </button>
                                  <button
                                    type="button"
                                    disabled={idx === links.length - 1}
                                    onClick={() => moveFooterLink(colKey, idx, idx + 1)}
                                    className="admin-btn admin-btn-sm admin-btn-secondary"
                                    style={{ padding: '2px 5px', fontSize: 9, lineHeight: 1, minHeight: 'auto', opacity: idx === links.length - 1 ? 0.3 : 1 }}
                                    title="Lëviz poshtë"
                                  >
                                    ▼
                                  </button>
                                </div>
                                <input
                                  type="checkbox"
                                  checked={!!link.isHeader}
                                  onChange={(e) => handleFooterLinkChange(colKey, idx, 'isHeader', e.target.checked)}
                                  title="Bëje Titull Kolone (Header)"
                                  style={{ cursor: 'pointer' }}
                                />
                                <input
                                  className="admin-input"
                                  value={link.text}
                                  onChange={(e) => handleFooterLinkChange(colKey, idx, 'text', e.target.value)}
                                  placeholder="Teksti"
                                  style={{ flex: 1, marginBottom: 0, fontWeight: link.isHeader ? 'bold' : 'normal', fontSize: 13 }}
                                />
                                <input
                                  className="admin-input"
                                  value={link.href}
                                  onChange={(e) => handleFooterLinkChange(colKey, idx, 'href', e.target.value)}
                                  placeholder="URL"
                                  style={{ flex: 1, marginBottom: 0, fontSize: 13 }}
                                />
                                <button
                                  type="button"
                                  onClick={() => removeFooterLink(colKey, idx)}
                                  className="admin-btn admin-btn-sm admin-btn-danger"
                                  style={{ padding: '6px 10px' }}
                                  title="Fshi linkun"
                                >
                                  ✕
                                </button>
                              </div>
                            ))
                          )}
                        </div>
                      );
                    })}
                  </div>


                </>
            )}

            {activeTab === 'regional' && (
                <>
                  <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 -8px', paddingBottom: 8 }}>Regional</h2>
                  <div className="admin-card">
                    <h3 className="admin-subtitle">Currency & Exchange Rates</h3>
                    <p className="admin-text" style={{ marginBottom: 16 }}>Value of 1 foreign unit in local currency (ALL).</p>
                    <div className="admin-grid">
                      <div className="admin-form-group">
                        <label className="admin-label">EUR Rate (1€)</label>
                        <div style={{ position: 'relative' }}>
                          <span style={{ position: 'absolute', left: 12, top: 10, color: '#64748b' }}>L</span>
                          <input
                              type="number"
                              step="0.01"
                              className="admin-input"
                              style={{ paddingLeft: 30 }}
                              value={settings.exchange_rate_eur}
                              onChange={(e) => handleChange('exchange_rate_eur', e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">USD Rate (1$)</label>
                        <div style={{ position: 'relative' }}>
                          <span style={{ position: 'absolute', left: 12, top: 10, color: '#64748b' }}>L</span>
                          <input
                              type="number"
                              step="0.01"
                              className="admin-input"
                              style={{ paddingLeft: 30 }}
                              value={settings.exchange_rate_usd}
                              onChange={(e) => handleChange('exchange_rate_usd', e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                </>
            )}

            {activeTab === 'sync' && (
                <>
                  <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 -8px', paddingBottom: 8 }}>Background Sync</h2>

                  <div className="admin-card" style={{ marginBottom: 24, padding: 20 }}>
                    <h3 className="admin-subtitle" style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
                      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                      Sync Status Monitor
                    </h3>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
                      {[
                        { label: 'Exchange Rates', key: 'currency_last_sync_at', color: '#f59e0b' },
                        { label: 'Globe JSON Feed', key: 'globe_last_sync_at', color: '#8b5cf6' },
                        { label: 'Categories Sync', key: 'globe_category_last_sync_at', color: '#ec4899' },
                        { label: 'Spec Filters Sync', key: 'globe_spec_filters_last_sync_at', color: '#10b981' },
                      ].map((item) => (
                          <div key={item.key} style={{ padding: '12px 16px', background: '#f8fafc', borderRadius: 12, border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <div style={{ width: 8, height: 8, borderRadius: '50%', background: item.color }} />
                              <span style={{ fontSize: 13, fontWeight: 600, color: '#475569' }}>{item.label}</span>
                            </div>
                            <div style={{ fontSize: 12, color: '#64748b' }}>
                              Last: <span style={{ fontWeight: 500, color: '#0f172a' }}>{formatLastSync(settings[item.key])}</span>
                            </div>
                          </div>
                      ))}
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Background Sync Intervals</h3>
                    <p className="admin-text" style={{ marginBottom: 16 }}>Set how often each background task runs automatically. Note: these apply automatically when you save.</p>
                    <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
                      <IntervalInput
                          label="Sync Currency"
                          value={settings.sync_interval_currency}
                          onChange={(v) => handleChange('sync_interval_currency', v)}
                          actionButton={
                            <button type="button" onClick={handleSyncCurrency} className="admin-btn admin-btn-secondary admin-btn-sm" disabled={currencySync.loading}>
                              {currencySync.loading ? 'Syncing…' : 'Sync Currency'}
                            </button>
                          }
                      />
                      <IntervalInput
                          label="Refresh Globe JSON"
                          value={settings.sync_interval_globe}
                          onChange={(v) => handleChange('sync_interval_globe', v)}
                          actionButton={
                            <button type="button" onClick={handleImportGlobeProducts} className="admin-btn admin-btn-secondary admin-btn-sm" disabled={globeImportSync.loading}>
                              {globeImportSync.loading ? 'Refreshing…' : 'Refresh Globe JSON'}
                            </button>
                          }
                      />
                      <IntervalInput
                          label="Sync Globe Categories"
                          value={settings.sync_interval_globe_categories}
                          onChange={(v) => handleChange('sync_interval_globe_categories', v)}
                          actionButton={
                            <button type="button" onClick={handleSyncGlobeCategories} className="admin-btn admin-btn-secondary admin-btn-sm" disabled={globeCategorySync.loading}>
                              {globeCategorySync.loading ? 'Syncing…' : 'Sync Categories'}
                            </button>
                          }
                      />
                      <IntervalInput
                          label="Sync Globe Spec Filters"
                          value={settings.sync_interval_globe_spec_filters}
                          onChange={(v) => handleChange('sync_interval_globe_spec_filters', v)}
                          actionButton={
                            <button type="button" onClick={handleSyncGlobeSpecFilters} className="admin-btn admin-btn-secondary admin-btn-sm" disabled={globeSpecFiltersSync.loading}>
                              {globeSpecFiltersSync.loading ? 'Syncing…' : 'Sync Spec Filters'}
                            </button>
                          }
                      />
                    </div>
                  </div>

                </>
            )}

            {activeTab === 'payments' && (
                <>
                  <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 -8px', paddingBottom: 8 }}>Payment Gateways</h2>
                  <div className="admin-card">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, borderBottom: '1px solid #e2e8f0', paddingBottom: 12 }}>
                      <div style={{ fontSize: 16, fontWeight: 600, color: '#0f172a' }}>UPC Payments</div>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
                    <span style={{ fontSize: 13, fontWeight: 500, color: settings.upc_enabled === 'true' ? '#0b74de' : '#64748b' }}>
                      {settings.upc_enabled === 'true' ? 'Enabled' : 'Disabled'}
                    </span>
                        <div onClick={() => handleChange('upc_enabled', settings.upc_enabled === 'true' ? 'false' : 'true')} style={{
                          position: 'relative', width: 44, height: 24, background: settings.upc_enabled === 'true' ? '#0b74de' : '#cbd5e1', borderRadius: 12, transition: '0.2s'
                        }}>
                          <div style={{
                            position: 'absolute', top: 2, left: 2, width: 20, height: 20, background: '#fff', borderRadius: '50%',
                            transform: settings.upc_enabled === 'true' ? 'translateX(20px)' : 'translateX(0)', transition: '0.2s'
                          }} />
                        </div>
                      </label>
                    </div>

                    <div style={{ opacity: settings.upc_enabled === 'true' ? 1 : 0.6, pointerEvents: settings.upc_enabled === 'true' ? 'auto' : 'none', transition: 'opacity 0.2s' }}>
                      <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
                        <div className="admin-form-group">
                          <label className="admin-label">Merchant ID</label>
                          <input className="admin-input" value={settings.upc_merchant_id || ''} onChange={(e) => handleChange('upc_merchant_id', e.target.value)} />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">Terminal ID</label>
                          <input className="admin-input" value={settings.upc_terminal_id || ''} onChange={(e) => handleChange('upc_terminal_id', e.target.value)} />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">Currency (ISO numeric)</label>
                          <input className="admin-input" placeholder="e.g. 978 for EUR, 008 for ALL" value={settings.upc_currency || ''} onChange={(e) => handleChange('upc_currency', e.target.value)} />
                          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Must be a 3-digit ISO 4217 numeric code.</div>
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">Gateway URL</label>
                          <input className="admin-input" placeholder="https://ecg.test.upc.ua/rbal/enter" value={settings.upc_gateway_url || ''} onChange={(e) => handleChange('upc_gateway_url', e.target.value)} />
                          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Test URL or Production URL.</div>
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">Merchant Name (CN)</label>
                          <input className="admin-input" placeholder="www.globe.com.al" value={settings.upc_merchant_name || ''} onChange={(e) => handleChange('upc_merchant_name', e.target.value)} />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">Language</label>
                          <input className="admin-input" placeholder="EN" value={settings.upc_language || ''} onChange={(e) => handleChange('upc_language', e.target.value)} />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">Order Prefix</label>
                          <input className="admin-input" placeholder="optional e.g., GLOBE-" value={settings.upc_order_prefix || ''} onChange={(e) => handleChange('upc_order_prefix', e.target.value)} />
                        </div>
                        <div className="admin-form-group" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                          <label className="admin-label">Strict Parameter Names</label>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <input type="checkbox" checked={!!settings.upc_strict_names} onChange={(e) => handleChange('upc_strict_names', e.target.checked)} />
                            <span className="admin-text">Send only TotalAmount/CurrencyID</span>
                          </div>
                        </div>
                      </div>

                      <h4 style={{ fontSize: 13, fontWeight: 700, color: '#475569', marginTop: 24, marginBottom: 12, borderBottom: '1px solid #f1f5f9', paddingBottom: 6 }}>Certificates & Keys (Server Paths)</h4>
                      <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))' }}>
                        <div className="admin-form-group">
                          <label className="admin-label">Private Key Path (.pem)</label>
                          <input className="admin-input" placeholder="./server/certs/<merchant>.pem" value={settings.upc_private_key_path || ''} onChange={(e) => handleChange('upc_private_key_path', e.target.value)} />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">UPC Server Cert Path (.crt)</label>
                          <input className="admin-input" placeholder="./server/certs/test-server.crt" value={settings.upc_server_cert_path || ''} onChange={(e) => handleChange('upc_server_cert_path', e.target.value)} />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">Merchant Certificate Path (.crt)</label>
                          <input className="admin-input" placeholder="./server/certs/<merchant>.crt" value={settings.upc_merchant_cert_path || ''} onChange={(e) => handleChange('upc_merchant_cert_path', e.target.value)} />
                        </div>
                      </div>

                      {/* Health Check and Debug Actions - Styled as a toolbar */}
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 24, padding: 12, background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0' }}>
                        <button type="button" onClick={runHealthCheck} className="admin-btn admin-btn-secondary admin-btn-sm" style={{ borderColor: '#94a3b8' }}>
                          {health.loading ? 'Checking…' : 'Run Health Check'}
                        </button>
                        <button type="button" onClick={loadDebugLatest} className="admin-btn admin-btn-secondary admin-btn-sm" style={{ borderColor: '#94a3b8' }}>
                          {debugLatest.loading ? 'Loading…' : 'Latest Payloads'}
                        </button>
                        <button type="button" onClick={replayLatest} className="admin-btn admin-btn-secondary admin-btn-sm" style={{ borderColor: '#94a3b8' }}>
                          {debugSubmit.loading ? 'Replaying…' : 'Replay Latest'}
                        </button>
                        <button type="button" onClick={replayLatestGoPay} className="admin-btn admin-btn-secondary admin-btn-sm" style={{ borderColor: '#94a3b8' }}>
                          {debugSubmit.loading ? 'Replaying…' : 'Replay Latest (go/pay)'}
                        </button>
                        <button type="button" onClick={pingApi} className="admin-btn admin-btn-secondary admin-btn-sm" style={{ borderColor: '#94a3b8' }}>
                          {apiPing.loading ? 'Pinging…' : 'Ping API'}
                        </button>

                        <div style={{ flex: '1 0 100%', height: 1, background: '#e2e8f0', margin: '4px 0' }} />

                        {/* Health Results */}
                        {health.result && (
                            <div style={{ width: '100%', fontSize: 13 }}>
                              <div style={{ fontWeight: 700, color: health.result.ok ? '#10b981' : '#ef4444', marginBottom: 8 }}>Result: {health.result.ok ? 'OK' : 'Issues detected'}</div>
                              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 8, color: '#334155' }}>
                                <div>Enabled: <strong>{String(health.result.config?.enabled)}</strong></div>
                                <div>MerchantID: <strong>{health.result.config?.merchantId_ok ? 'OK' : 'Invalid'}</strong></div>
                                <div>TerminalID: <strong>{health.result.config?.terminalId_ok ? 'OK' : 'Invalid'}</strong></div>
                                <div>Currency: <strong>{health.result.config?.currency_ok ? 'OK' : 'Invalid'}</strong></div>
                                <div>PrivKey: <strong>{health.result.config?.privateKey_exists ? 'Found' : 'Missing'}</strong></div>
                                <div>SrvCert: <strong>{health.result.config?.serverCert_exists ? 'Found' : 'Missing'}</strong></div>
                                <div>MerchCert: <strong>{health.result.config?.merchantCert_exists ? 'Found' : 'Missing'}</strong></div>
                              </div>
                            </div>
                        )}
                        {health.error && <div style={{ width: '100%', color: '#ef4444', fontSize: 13 }}>Error: {health.error}</div>}

                        {/* Debug Latest */}
                        {debugLatest.entries && debugLatest.entries.length > 0 && (
                            <div style={{ width: '100%', marginTop: 8 }}>
                              <div style={{ fontSize: 12, fontWeight: 600, color: '#64748b' }}>Recent Payloads</div>
                              {debugLatest.entries.slice(-3).map((e, i) => (
                                  <div key={i} style={{ fontSize: 11, padding: 6, borderBottom: '1px solid #e2e8f0', color: '#334155' }}>
                                    {e.ts} | {e.actionUrl} | OID:{e.fields?.OrderID || e.orderId}
                                  </div>
                              ))}
                            </div>
                        )}

                        {/* Replay Result */}
                        {debugSubmit.result && (
                            <div style={{ width: '100%', marginTop: 8, padding: 8, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 4 }}>
                              <div style={{ fontSize: 13, fontWeight: 600 }}>Replay Result: {String(debugSubmit.result.status)}</div>
                              {debugSubmit.result.reason && <div style={{ fontSize: 12, color: '#ef4444' }}>{debugSubmit.result.reason}</div>}
                            </div>
                        )}
                      </div>

                      <div style={{ marginTop: 24, padding: 16, background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0' }}>
                        <h4 className="admin-subtitle" style={{ fontSize: 14, margin: '0 0 12px 0' }}>Integration Webhooks</h4>
                        <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
                          <div>
                            <div className="admin-label" style={{ fontSize: 11 }}>Success URL</div>
                            <code style={{ display: 'block', padding: 8, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 4, fontSize: 12, color: '#444' }}>{API_BASE_URL}/payment/success</code>
                          </div>
                          <div>
                            <div className="admin-label" style={{ fontSize: 11 }}>Failure URL</div>
                            <code style={{ display: 'block', padding: 8, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 4, fontSize: 12, color: '#444' }}>{API_BASE_URL}/payment/failure</code>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* Credins Payment Gateway */}
                  <div className="admin-card" style={{ marginTop: 24 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, borderBottom: '1px solid #e2e8f0', paddingBottom: 12 }}>
                      <div style={{ fontSize: 16, fontWeight: 600, color: '#0f172a' }}>Credins Payments</div>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
                    <span style={{ fontSize: 13, fontWeight: 500, color: settings.credins_enabled === 'true' ? '#0b74de' : '#64748b' }}>
                      {settings.credins_enabled === 'true' ? 'Enabled' : 'Disabled'}
                    </span>
                        <div onClick={() => handleChange('credins_enabled', settings.credins_enabled === 'true' ? 'false' : 'true')} style={{
                          position: 'relative', width: 44, height: 24, background: settings.credins_enabled === 'true' ? '#0b74de' : '#cbd5e1', borderRadius: 12, transition: '0.2s'
                        }}>
                          <div style={{
                            position: 'absolute', top: 2, left: 2, width: 20, height: 20, background: '#fff', borderRadius: '50%',
                            transform: settings.credins_enabled === 'true' ? 'translateX(20px)' : 'translateX(0)', transition: '0.2s'
                          }} />
                        </div>
                      </label>
                    </div>

                <div style={{ opacity: settings.credins_enabled === 'true' ? 1 : 0.6, pointerEvents: settings.credins_enabled === 'true' ? 'auto' : 'none', transition: 'opacity 0.2s' }}>
                  <div style={{ fontSize: 12, color: '#64748b', marginBottom: 16, background: '#f8fafc', borderRadius: 8, padding: '10px 14px', border: '1px solid #e2e8f0' }}>
                    ℹ️ Credins Bank uses SIA VPOS Redirect. Authentication is HMAC-SHA256 with secret keys provided by the bank — <strong>no certificate files required</strong>.
                  </div>
                  <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
                    <div className="admin-form-group">
                      <label className="admin-label">SHOPID</label>
                      <input className="admin-input" placeholder="Provided by Credins Bank" value={settings.credins_shopid || ''} onChange={(e) => handleChange('credins_shopid', e.target.value)} />
                      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Merchant identifier issued by the bank (SHOPID field).</div>
                    </div>
                    <div className="admin-form-group">
                      <label className="admin-label">Currency (ISO numeric)</label>
                      <input className="admin-input" placeholder="e.g. 978 for EUR, 008 for ALL" value={settings.credins_currency || ''} onChange={(e) => handleChange('credins_currency', e.target.value)} />
                      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>3-digit ISO 4217 numeric code.</div>
                    </div>
                    <div className="admin-form-group">
                      <label className="admin-label">Gateway URL</label>
                      <input className="admin-input" placeholder="https://virtualpos.sia.eu/vpos/payments/main?PAGE=LAND" value={settings.credins_gateway_url || ''} onChange={(e) => handleChange('credins_gateway_url', e.target.value)} />
                      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Test: virtualpostest.sia.eu | Prod: virtualpos.sia.eu</div>
                    </div>
                    <div className="admin-form-group">
                      <label className="admin-label">Language</label>
                      <input className="admin-input" placeholder="AL" value={settings.credins_language || ''} onChange={(e) => handleChange('credins_language', e.target.value)} />
                      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>AL, EN, etc.</div>
                    </div>
                    <div className="admin-form-group">
                      <label className="admin-label">Order Prefix</label>
                      <input className="admin-input" placeholder="optional, e.g. CR-" value={settings.credins_order_prefix || ''} onChange={(e) => handleChange('credins_order_prefix', e.target.value)} />
                    </div>
                    <div className="admin-form-group">
                      <label className="admin-label">Accounting Mode</label>
                      <select className="admin-input" value={settings.credins_accounting_mode || 'I'} onChange={(e) => handleChange('credins_accounting_mode', e.target.value)}>
                        <option value="I">I – Immediate</option>
                        <option value="D">D – Deferred</option>
                      </select>
                    </div>
                    <div className="admin-form-group">
                      <label className="admin-label">Author Mode</label>
                      <select className="admin-input" value={settings.credins_author_mode || 'I'} onChange={(e) => handleChange('credins_author_mode', e.target.value)}>
                        <option value="I">I – Implicit</option>
                      </select>
                    </div>
                    <div className="admin-form-group">
                      <label className="admin-label">Card Network</label>
                      <select className="admin-input" value={settings.credins_network || '0'} onChange={(e) => handleChange('credins_network', e.target.value)}>
                        <option value="0">0 – All cards</option>
                        <option value="1">1 – Visa only</option>
                        <option value="2">2 – Mastercard only</option>
                      </select>
                    </div>
                  </div>

                  <h4 style={{ fontSize: 13, fontWeight: 700, color: '#475569', marginTop: 24, marginBottom: 12, borderBottom: '1px solid #f1f5f9', paddingBottom: 6 }}>HMAC Secret Keys (provided by Credins Bank)</h4>
                  <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))' }}>
                    <div className="admin-form-group">
                      <label className="admin-label">Start Key (Initiation MAC)</label>
                      <input type="password" className="admin-input" placeholder="Paste the Start Key here" value={settings.credins_start_key || ''} onChange={(e) => handleChange('credins_start_key', e.target.value)} autoComplete="new-password" />
                      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Used to sign the payment initiation request.</div>
                    </div>
                    <div className="admin-form-group">
                      <label className="admin-label">API-Result Key (Response MAC)</label>
                      <input type="password" className="admin-input" placeholder="Paste the API-Result Key here" value={settings.credins_api_result_key || ''} onChange={(e) => handleChange('credins_api_result_key', e.target.value)} autoComplete="new-password" />
                      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Used to verify the bank's callback response.</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Iute Payment Gateway */}
              <div className="admin-card" style={{ marginTop: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, borderBottom: '1px solid #e2e8f0', paddingBottom: 12 }}>
                  <div style={{ fontSize: 16, fontWeight: 600, color: '#0f172a' }}>Iute Payments</div>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
                    <span style={{ fontSize: 13, fontWeight: 500, color: settings.iute_enabled === 'true' ? '#0b74de' : '#64748b' }}>
                      {settings.iute_enabled === 'true' ? 'Enabled' : 'Disabled'}
                    </span>
                    <div onClick={() => handleChange('iute_enabled', settings.iute_enabled === 'true' ? 'false' : 'true')} style={{
                      position: 'relative', width: 44, height: 24, background: settings.iute_enabled === 'true' ? '#0b74de' : '#cbd5e1', borderRadius: 12, transition: '0.2s'
                    }}>
                      <div style={{
                        position: 'absolute', top: 2, left: 2, width: 20, height: 20, background: '#fff', borderRadius: '50%',
                        transform: settings.iute_enabled === 'true' ? 'translateX(20px)' : 'translateX(0)', transition: '0.2s'
                      }} />
                    </div>
                  </label>
                </div>

                <div style={{ opacity: settings.iute_enabled === 'true' ? 1 : 0.6, pointerEvents: settings.iute_enabled === 'true' ? 'auto' : 'none', transition: 'opacity 0.2s' }}>
                  <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
                    <div className="admin-form-group">
                      <label className="admin-label">Public / API Key</label>
                      <input className="admin-input" placeholder="Paste the Iute Public Key here" value={settings.iute_public_key || ''} onChange={(e) => handleChange('iute_public_key', e.target.value)} />
                      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Used to initialize the Iute checkout on the frontend.</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Payment Gateway Scheduling */}
              <div className="admin-card" style={{ marginTop: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, borderBottom: '1px solid #e2e8f0', paddingBottom: 12 }}>
                  <div style={{ fontSize: 16, fontWeight: 600, color: '#0f172a' }}>Payment Gateway Routing / Schedule</div>
                </div>

                <div className="admin-grid" style={{ gridTemplateColumns: '1fr' }}>
                  <div className="admin-form-group">
                    <label className="admin-label">Routing Strategy</label>
                    <select
                        className="admin-input"
                        value={settings.payment_gateway_mode || 'upc'}
                        onChange={(e) => handleChange('payment_gateway_mode', e.target.value)}
                    >
                      <option value="upc">Always use UPC Configurations</option>
                      <option value="credins">Always use Credins Configurations</option>
                      <option value="schedule">Schedule Mode</option>
                    </select>
                  </div>

                  <div className="admin-form-group">
                    <label className="admin-label">Payment Callback Root URL (Domain)</label>
                    <input
                      className="admin-input"
                      placeholder="e.g., https://globe.al"
                      value={settings.payment_server_root || ''}
                      onChange={(e) => handleChange('payment_server_root', e.target.value)}
                    />
                    <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
                      Override backend URL domain for transaction callbacks/redirects. Crucial if the server runs behind a proxy. Leave empty to use system default host header.
                    </div>
                  </div>

                  {settings.payment_gateway_mode === 'schedule' && (
                      <div style={{ padding: 16, background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0', marginTop: 8 }}>
                        <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', marginBottom: 0 }}>
                          <div className="admin-form-group">
                            <label className="admin-label">Primary Gateway</label>
                            <select
                                className="admin-input"
                                value={settings.payment_schedule_primary || 'upc'}
                                onChange={(e) => handleChange('payment_schedule_primary', e.target.value)}
                            >
                              <option value="upc">UPC</option>
                              <option value="credins">Credins</option>
                            </select>
                          </div>
                          <div className="admin-form-group">
                            <label className="admin-label">Anchor Date</label>
                            <input type="date" className="admin-input" value={settings.payment_schedule_anchor_date || '2024-01-01'} onChange={(e) => handleChange('payment_schedule_anchor_date', e.target.value)} />
                          </div>
                          <div className="admin-form-group">
                            <label className="admin-label">Rotation Interval (Days)</label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <input type="number" min="1" className="admin-input" value={settings.payment_schedule_rotation_days || '15'} onChange={(e) => handleChange('payment_schedule_rotation_days', e.target.value)} />
                              <span style={{ fontSize: 13, color: '#64748b', whiteSpace: 'nowrap' }}>days per gateway</span>
                            </div>
                          </div>
                        </div>
                        <p style={{ margin: '12px 0 0 0', fontSize: 12, color: '#64748b' }}>
                          The active gateway rotates every <strong>{settings.payment_schedule_rotation_days || '15'} days</strong>.
                          Starting from <strong>{settings.payment_schedule_anchor_date || '2024-01-01'}</strong>, the system will use <strong>{String(settings.payment_schedule_primary || 'upc').toUpperCase()}</strong> for the first {settings.payment_schedule_rotation_days || '15'} days, then switch to <strong>{String(settings.payment_schedule_primary || 'upc') === 'upc' ? 'CREDINS' : 'UPC'}</strong> for the next {settings.payment_schedule_rotation_days || '15'} days, and repeat continuously.
                        </p>
                      </div>
                  )}
                </div>
              </div>

                </>
            )}

            {activeTab === 'email' && (
                <>
                  <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 -8px', paddingBottom: 8 }}>Email Settings</h2>
                  <div className="admin-card">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, borderBottom: '1px solid #e2e8f0', paddingBottom: 12 }}>
                      <div style={{ fontSize: 16, fontWeight: 600, color: '#0f172a' }}>Email Notifications</div>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
                    <span style={{ fontSize: 13, fontWeight: 500, color: settings.email_enabled === 'true' ? '#0b74de' : '#64748b' }}>
                      {settings.email_enabled === 'true' ? 'Enabled' : 'Disabled'}
                    </span>
                        <div onClick={() => handleChange('email_enabled', settings.email_enabled === 'true' ? 'false' : 'true')} style={{
                          position: 'relative', width: 44, height: 24, background: settings.email_enabled === 'true' ? '#0b74de' : '#cbd5e1', borderRadius: 12, transition: '0.2s'
                        }}>
                          <div style={{
                            position: 'absolute', top: 2, left: 2, width: 20, height: 20, background: '#fff', borderRadius: '50%',
                            transform: settings.email_enabled === 'true' ? 'translateX(20px)' : 'translateX(0)', transition: '0.2s'
                          }} />
                        </div>
                      </label>
                    </div>

                    <div style={{ opacity: settings.email_enabled === 'true' ? 1 : 0.6, pointerEvents: settings.email_enabled === 'true' ? 'auto' : 'none', transition: 'opacity 0.2s' }}>
                      <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
                        <div className="admin-form-group">
                          <label className="admin-label">SMTP Host</label>
                          <input className="admin-input" value={settings.email_smtp_host || ''} onChange={(e) => handleChange('email_smtp_host', e.target.value)} placeholder="smtp.inmotionhosting.com" />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">SMTP Port</label>
                          <input className="admin-input" value={settings.email_smtp_port || ''} onChange={(e) => handleChange('email_smtp_port', e.target.value)} placeholder="587" />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">SMTP User</label>
                          <input className="admin-input" value={settings.email_smtp_user || ''} onChange={(e) => handleChange('email_smtp_user', e.target.value)} placeholder="user@example.com" />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">SMTP Password</label>
                          <input type="password" className="admin-input" value={settings.email_smtp_pass || ''} onChange={(e) => handleChange('email_smtp_pass', e.target.value)} />
                        </div>
                        <div className="admin-form-group" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                          <label className="admin-label">Use TLS (secure)</label>
                          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <input type="checkbox" checked={settings.email_smtp_secure === 'true'} onChange={(e) => handleChange('email_smtp_secure', e.target.checked ? 'true' : 'false')} />
                            <span className="admin-text">Enable for port 465</span>
                          </label>
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">From Name</label>
                          <input className="admin-input" value={settings.email_from_name || ''} onChange={(e) => handleChange('email_from_name', e.target.value)} placeholder="Globe Albania" />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">From Email</label>
                          <input className="admin-input" value={settings.email_from_email || ''} onChange={(e) => handleChange('email_from_email', e.target.value)} placeholder="no-reply@globe.com.al" />
                        </div>
                      </div>

                      <div style={{ marginTop: 16, fontSize: 12, color: '#64748b' }}>
                        Available variables: {'{{orderId}}'}, {'{{name}}'}, {'{{email}}'}, {'{{phone}}'}, {'{{total}}'}, {'{{currency}}'}, {'{{address}}'}, {'{{city}}'}, {'{{paymentMethod}}'}, {'{{pickupMethod}}'}, {'{{productName}}'}, {'{{quantity}}'}, {'{{status}}'}
                      </div>
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Templates - Processing</h3>
                    <div className="admin-grid" style={{ gridTemplateColumns: '1fr' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Subject</label>
                        <input className="admin-input" value={settings.email_tpl_processing_subject || ''} onChange={(e) => handleChange('email_tpl_processing_subject', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Text</label>
                        <textarea className="admin-input" rows={4} value={settings.email_tpl_processing_text || ''} onChange={(e) => handleChange('email_tpl_processing_text', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">HTML</label>
                        <textarea className="admin-input" rows={5} value={settings.email_tpl_processing_html || ''} onChange={(e) => handleChange('email_tpl_processing_html', e.target.value)} />
                      </div>
                    </div>
                    <div style={{ marginTop: 12, fontSize: 12, color: '#64748b' }}>
                      Available variables: {'{{orderId}}'}, {'{{name}}'}, {'{{email}}'}, {'{{phone}}'}, {'{{total}}'}, {'{{currency}}'}, {'{{address}}'}, {'{{city}}'}, {'{{paymentMethod}}'}, {'{{pickupMethod}}'}, {'{{productName}}'}, {'{{quantity}}'}, {'{{status}}'}
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Templates - Delivered</h3>
                    <div className="admin-grid" style={{ gridTemplateColumns: '1fr' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Subject</label>
                        <input className="admin-input" value={settings.email_tpl_delivered_subject || ''} onChange={(e) => handleChange('email_tpl_delivered_subject', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Text</label>
                        <textarea className="admin-input" rows={4} value={settings.email_tpl_delivered_text || ''} onChange={(e) => handleChange('email_tpl_delivered_text', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">HTML</label>
                        <textarea className="admin-input" rows={5} value={settings.email_tpl_delivered_html || ''} onChange={(e) => handleChange('email_tpl_delivered_html', e.target.value)} />
                      </div>
                    </div>
                    <div style={{ marginTop: 12, fontSize: 12, color: '#64748b' }}>
                      Available variables: {'{{orderId}}'}, {'{{name}}'}, {'{{email}}'}, {'{{phone}}'}, {'{{total}}'}, {'{{currency}}'}, {'{{address}}'}, {'{{city}}'}, {'{{paymentMethod}}'}, {'{{pickupMethod}}'}, {'{{productName}}'}, {'{{quantity}}'}, {'{{status}}'}
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Templates - Cancelled</h3>
                    <div className="admin-grid" style={{ gridTemplateColumns: '1fr' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Subject</label>
                        <input className="admin-input" value={settings.email_tpl_cancelled_subject || ''} onChange={(e) => handleChange('email_tpl_cancelled_subject', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Text</label>
                        <textarea className="admin-input" rows={4} value={settings.email_tpl_cancelled_text || ''} onChange={(e) => handleChange('email_tpl_cancelled_text', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">HTML</label>
                        <textarea className="admin-input" rows={5} value={settings.email_tpl_cancelled_html || ''} onChange={(e) => handleChange('email_tpl_cancelled_html', e.target.value)} />
                      </div>
                    </div>
                    <div style={{ marginTop: 12, fontSize: 12, color: '#64748b' }}>
                      Available variables: {'{{orderId}}'}, {'{{name}}'}, {'{{email}}'}, {'{{phone}}'}, {'{{total}}'}, {'{{currency}}'}, {'{{address}}'}, {'{{city}}'}, {'{{paymentMethod}}'}, {'{{pickupMethod}}'}, {'{{productName}}'}, {'{{quantity}}'}, {'{{status}}'}
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Templates - Returned</h3>
                    <div className="admin-grid" style={{ gridTemplateColumns: '1fr' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Subject</label>
                        <input className="admin-input" value={settings.email_tpl_returned_subject || ''} onChange={(e) => handleChange('email_tpl_returned_subject', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Text</label>
                        <textarea className="admin-input" rows={4} value={settings.email_tpl_returned_text || ''} onChange={(e) => handleChange('email_tpl_returned_text', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">HTML</label>
                        <textarea className="admin-input" rows={5} value={settings.email_tpl_returned_html || ''} onChange={(e) => handleChange('email_tpl_returned_html', e.target.value)} />
                      </div>
                    </div>
                    <div style={{ marginTop: 12, fontSize: 12, color: '#64748b' }}>
                      Available variables: {'{{orderId}}'}, {'{{name}}'}, {'{{email}}'}, {'{{phone}}'}, {'{{total}}'}, {'{{currency}}'}, {'{{address}}'}, {'{{city}}'}, {'{{paymentMethod}}'}, {'{{pickupMethod}}'}, {'{{productName}}'}, {'{{quantity}}'}, {'{{status}}'}
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Admin Notification — New Order Placed</h3>
                    <p className="admin-text" style={{ marginBottom: 16 }}>
                      Sent to the admin email below whenever a customer places an order.
                    </p>
                    <div className="admin-grid" style={{ gridTemplateColumns: '1fr' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Admin Notify Email</label>
                        <input
                            className="admin-input"
                            value={settings.email_admin_notify_email || ''}
                            onChange={(e) => handleChange('email_admin_notify_email', e.target.value)}
                            placeholder="info@globe.al"
                        />
                        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
                          If empty, falls back to Support Email or From Email.
                        </div>
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Subject</label>
                        <input className="admin-input" value={settings.email_tpl_order_placed_subject || ''} onChange={(e) => handleChange('email_tpl_order_placed_subject', e.target.value)} placeholder="New Order #{{orderId}} placed" />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Text</label>
                        <textarea className="admin-input" rows={4} value={settings.email_tpl_order_placed_text || ''} onChange={(e) => handleChange('email_tpl_order_placed_text', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">HTML</label>
                        <textarea className="admin-input" rows={5} value={settings.email_tpl_order_placed_html || ''} onChange={(e) => handleChange('email_tpl_order_placed_html', e.target.value)} />
                      </div>
                    </div>
                    <div style={{ marginTop: 12, fontSize: 12, color: '#64748b' }}>
                      Available variables: {'{{orderId}}'}, {'{{name}}'}, {'{{email}}'}, {'{{phone}}'}, {'{{total}}'}, {'{{currency}}'}, {'{{address}}'}, {'{{city}}'}, {'{{paymentMethod}}'}, {'{{pickupMethod}}'}, {'{{productName}}'}, {'{{quantity}}'}, {'{{status}}'}
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">Customer Confirmation — Order Placed</h3>
                    <p className="admin-text" style={{ marginBottom: 16 }}>
                      Sent to the customer immediately after they place an order.
                    </p>
                    <div className="admin-grid" style={{ gridTemplateColumns: '1fr' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Subject</label>
                        <input className="admin-input" value={settings.email_tpl_customer_order_placed_subject || ''} onChange={(e) => handleChange('email_tpl_customer_order_placed_subject', e.target.value)} placeholder="Order #{{orderId}} Confirmation" />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Text</label>
                        <textarea className="admin-input" rows={4} value={settings.email_tpl_customer_order_placed_text || ''} onChange={(e) => handleChange('email_tpl_customer_order_placed_text', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">HTML</label>
                        <textarea className="admin-input" rows={5} value={settings.email_tpl_customer_order_placed_html || ''} onChange={(e) => handleChange('email_tpl_customer_order_placed_html', e.target.value)} />
                      </div>
                    </div>
                    <div style={{ marginTop: 12, fontSize: 12, color: '#64748b' }}>
                      Available variables: {'{{orderId}}'}, {'{{name}}'}, {'{{email}}'}, {'{{phone}}'}, {'{{total}}'}, {'{{currency}}'}, {'{{address}}'}, {'{{city}}'}, {'{{paymentMethod}}'}, {'{{pickupMethod}}'}, {'{{productName}}'}, {'{{quantity}}'}, {'{{status}}'}
                    </div>
                  </div>

                </>
            )}

            {activeTab === 'sms' && (
                <>
                  <h2 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 -8px', paddingBottom: 8 }}>SMS Settings</h2>
                  <div className="admin-card">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, borderBottom: '1px solid #e2e8f0', paddingBottom: 12 }}>
                      <div style={{ fontSize: 16, fontWeight: 600, color: '#0f172a' }}>SMS Gateway</div>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
                    <span style={{ fontSize: 13, fontWeight: 500, color: settings.sms_enabled === 'true' ? '#0b74de' : '#64748b' }}>
                      {settings.sms_enabled === 'true' ? 'Enabled' : 'Disabled'}
                    </span>
                        <div onClick={() => handleChange('sms_enabled', settings.sms_enabled === 'true' ? 'false' : 'true')} style={{
                          position: 'relative', width: 44, height: 24, background: settings.sms_enabled === 'true' ? '#0b74de' : '#cbd5e1', borderRadius: 12, transition: '0.2s'
                        }}>
                          <div style={{
                            position: 'absolute', top: 2, left: 2, width: 20, height: 20, background: '#fff', borderRadius: '50%',
                            transform: settings.sms_enabled === 'true' ? 'translateX(20px)' : 'translateX(0)', transition: '0.2s'
                          }} />
                        </div>
                      </label>
                    </div>

                    <div style={{ opacity: settings.sms_enabled === 'true' ? 1 : 0.6, pointerEvents: settings.sms_enabled === 'true' ? 'auto' : 'none', transition: 'opacity 0.2s' }}>
                      <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
                        <div className="admin-form-group">
                          <label className="admin-label">Provider</label>
                          <input className="admin-input" value={settings.sms_provider || ''} onChange={(e) => handleChange('sms_provider', e.target.value)} placeholder="Twilio / Vonage / MessageBird / One Albania" />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">API Key</label>
                          <input className="admin-input" value={settings.sms_api_key || ''} onChange={(e) => handleChange('sms_api_key', e.target.value)} />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">API Secret</label>
                          <input type="password" className="admin-input" value={settings.sms_api_secret || ''} onChange={(e) => handleChange('sms_api_secret', e.target.value)} />
                        </div>
                        <div className="admin-form-group">
                          <label className="admin-label">Sender ID</label>
                          <input className="admin-input" value={settings.sms_sender_id || ''} onChange={(e) => handleChange('sms_sender_id', e.target.value)} placeholder="GL0BE" />
                        </div>
                      </div>

                      <div style={{ marginTop: 16, fontSize: 12, color: '#64748b' }}>
                        Available variables: {'{'}{'{'}orderId{'}'}{'}'}, {'{'}{'{'}status{'}'}{'}'}, {'{'}{'{'}total{'}'}{'}'}, {'{'}{'{'}currency{'}'}{'}'}, {'{'}{'{'}name{'}'}{'}'}, {'{'}{'{'}phone{'}'}{'}'}
                      </div>
                    </div>
                  </div>

                  <div className="admin-card">
                    <h3 className="admin-subtitle">SMS Templates</h3>
                    <div className="admin-grid" style={{ gridTemplateColumns: '1fr' }}>
                      <div className="admin-form-group">
                        <label className="admin-label">Processing</label>
                        <textarea className="admin-input" rows={3} value={settings.sms_tpl_processing || ''} onChange={(e) => handleChange('sms_tpl_processing', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Delivered</label>
                        <textarea className="admin-input" rows={3} value={settings.sms_tpl_delivered || ''} onChange={(e) => handleChange('sms_tpl_delivered', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Cancelled</label>
                        <textarea className="admin-input" rows={3} value={settings.sms_tpl_cancelled || ''} onChange={(e) => handleChange('sms_tpl_cancelled', e.target.value)} />
                      </div>
                      <div className="admin-form-group">
                        <label className="admin-label">Returned</label>
                        <textarea className="admin-input" rows={3} value={settings.sms_tpl_returned || ''} onChange={(e) => handleChange('sms_tpl_returned', e.target.value)} />
                      </div>
                    </div>
                    <div style={{ marginTop: 12, fontSize: 12, color: '#64748b' }}>
                      Available variables: {'{{orderId}}'}, {'{{status}}'}, {'{{total}}'}, {'{{currency}}'}, {'{{name}}'}, {'{{phone}}'}, {'{{productName}}'}, {'{{quantity}}'}
                    </div>
                  </div>
                </>
            )}




          </form>
        </div>

        {/* Toast Notification */}
        {message && (
            <div style={{ position: 'fixed', bottom: 30, left: '50%', transform: 'translateX(-50%)', padding: '12px 24px', borderRadius: 8, color: '#fff', fontWeight: 500, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 1000, background: message.type === 'success' ? '#10B981' : '#EF4444' }}>
              {message.text}
            </div>
        )}
      </div>
  );
}
